export default "dist/images/block-testimonial-basic.7a2698e.png";